import _classCallCheck from "/Users/john/workspace/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/john/workspace/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
/**
 * @internal
 */
export var Parameters = /*#__PURE__*/function () {
  function Parameters(parameters) {
    _classCallCheck(this, Parameters);
    this.parameters = {};
    // for in is required here as the Grammar parser is adding to the prototype chain
    for (var param in parameters) {
      // eslint-disable-next-line no-prototype-builtins
      if (parameters.hasOwnProperty(param)) {
        this.setParam(param, parameters[param]);
      }
    }
  }
  _createClass(Parameters, [{
    key: "setParam",
    value: function setParam(key, value) {
      if (key) {
        this.parameters[key.toLowerCase()] = typeof value === "undefined" || value === null ? null : value.toString();
      }
    }
  }, {
    key: "getParam",
    value: function getParam(key) {
      if (key) {
        return this.parameters[key.toLowerCase()];
      }
    }
  }, {
    key: "hasParam",
    value: function hasParam(key) {
      return !!(key && this.parameters[key.toLowerCase()] !== undefined);
    }
  }, {
    key: "deleteParam",
    value: function deleteParam(key) {
      key = key.toLowerCase();
      if (this.hasParam(key)) {
        var value = this.parameters[key];
        delete this.parameters[key];
        return value;
      }
    }
  }, {
    key: "clearParams",
    value: function clearParams() {
      this.parameters = {};
    }
  }]);
  return Parameters;
}();